import { interviewRoutes } from "./interview-routes";

export default (router: any) => {
  interviewRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
